import { ClearRounded, EditRounded } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { action, API, controller } from "api";
import { AppContext } from "App";
import { Button } from "controls";
import { Alert, Dialog, Table, TableActions } from "layout";
import { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import AddEditCurr from "./AddEditCurr";
import { formatDate } from "hooks";

const Currencies = () => {
  const [currs, setCurrs] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [updData, setUpdData] = useState();
  const { setLoader, access } = useContext(AppContext);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  const getCurrencies = () => {
    setLoader(true);
    API(controller.Currency + action.GetAll).get((res) => {
      setLoader(false);
      setCurrs([...res.result]);
    });
  };

  useEffect(() => {
    getCurrencies();
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAddEdit = (val) => {
    setUpdData(val);
    setShowForm(true);
  };

  const handleDlt = (id) => {
    setAlert({
      isOpen: true,
      type: "confirmation",
      title: "Are you sure",
      subTitle: "You want to delete this currency?",
      onConfirm: () => {
        const onComplete = (res) => {
          if (res?.status === 200) {
            setCurrs((x) => [...x.filter((j) => j.id !== res.result.id)]);
            toast.success(res?.msg);
            setAlert({
              isOpen: false,
              type: "",
              title: "",
              subTitle: "",
            });
          } else {
            setAlert({
              isOpen: true,
              type: "warning",
              title: "Warning",
              subTitle: res?.msg,
            });
          }
        };
        API(controller.Currency).Delete(id, onComplete);
      },
    });
  };

  const ActionComp = (props) => (
    <TableActions>
      {access?.currency?.edit && (
        <Tooltip arrow title="Edit">
          <IconButton onClick={() => handleAddEdit(props)} size="small">
            <EditRounded className="!text-[18px]" />
          </IconButton>
        </Tooltip>
      )}

      {access?.currency?.delete && (
        <Tooltip arrow title="Delete">
          <IconButton
            onClick={() => handleDlt(props.id)}
            size="small"
            color="error"
          >
            <ClearRounded className="!text-[18px]" />
          </IconButton>
        </Tooltip>
      )}
    </TableActions>
  );

  const HeaderComp = () =>
    access?.currency?.create && (
      <Button
        onClick={() => handleAddEdit()}
        sx={{ width: { md: "180px", xs: "100%" } }}
      >
        Add Currency
      </Button>
    );

  return (
    <>
      <Table
        ActionComp={ActionComp}
        HeaderComp={HeaderComp}
        tblHead={[
          { id: "actions", label: "Actions" },
          { id: "currency", label: "Currency" },
          { id: "date", label: "Date" },
          { id: "user", label: "Create/Update User" },
        ]}
        tblData={currs.map((j) => ({
          ...j,
          currency: (
            <div>
              <span>{j.fullName}</span>
              <div className="text-[12px] font-bold">
                <span>{j.symbol}</span> | <span>{j.shortName}</span> |{" "}
                <span>{j.currencyUnit}</span>
              </div>
            </div>
          ),
          date: (
            <div className="flex flex-col text-[14px]">
              <div className="flex gap-2 items-center">
                <span className="font-medium">Create:</span>
                <span>{formatDate(j.createDate)}</span>
              </div>
              <div className="flex gap-2 items-center">
                <span className="font-medium">Update:</span>
                <span>{formatDate(j.lastUpdate)}</span>
              </div>
            </div>
          ),
          user: (
            <div className="flex flex-col text-[14px]">
              <div className="flex gap-2 items-center">
                <span className="font-medium">Create:</span>
                <span>{j.createUser?.fullName}</span>
              </div>
              <div className="flex gap-2 items-center">
                <span className="font-medium">Update:</span>
                {j.lastUpdateUser ? (
                  <span>{j.lastUpdateUser?.fullName}</span>
                ) : (
                  "-"
                )}
              </div>
            </div>
          ),
        }))}
      />
      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />

      {/* Edit Dialog */}
      {showForm && (
        <Dialog show={showForm} onClose={false} maxWidth="xs">
          <AddEditCurr {...{ updData, setShowForm, setCurrs, setAlert }} />
        </Dialog>
      )}
    </>
  );
};

export default Currencies;
